import React from 'react';
import { useLocation } from 'react-router-dom';
import styles from '../../../../css/NavigatorBar/NavigatorContents/navTermsNRefundsContent.module.css';
import { ReactComponent as DotSVG } from '../../../../assets/icons/svg/dot.svg';

// 취소·환불 규정과 추가 안내를 구획별로 렌더링하는 탭 컴포넌트
function NavTermsNRefundsContent({ ...data }) {
  const termsData = data.term;

  return (
    <div>
      {termsData.map((section, idx) => (
        <React.Fragment key={idx}>
          <div className={styles['terms-section']}>
            <h2 className={styles['terms-title']}>{section.title}</h2>
            <div className={styles['terms-content']}>
              {section.description && (
                <div className={styles['terms-desc']}>{section.description}</div>
              )}

              <ul className={styles['terms-list']}>
                {section.items.map((item, i) => {
                  const isObject = typeof item === 'object' && item !== null;
                  const text = isObject ? item.text : item;
                  const type = isObject ? item.type : 'item';
                  const baseClass =
                    idx === 0
                      ? `${styles['terms-item']} ${styles.special}`
                      : `${styles['terms-item']} ${styles.refund}`;

                  if (type === 'label') {
                    return (
                      <li key={i} className={`${styles['terms-item']} ${styles['terms-item-label']}`} style={item.emphasis ? { color: '#d32f2f' } : undefined}>
                        {text}
                      </li>
                    );
                  }

                  if (type === 'note') {
                    return (
                      <li key={i} className={`${styles['terms-item']} ${styles['terms-item-note']}`}>
                        {text}
                      </li>
                    );
                  }

                  return (
                    <li key={i} className={baseClass}>
                      <div className={styles.dotWrapper}>
                        <DotSVG />
                      </div>
                      {text}
                    </li>
                  );
                })}
              </ul>

              {/* extra */}
              {section.extra && section.extra.type === 'link' && (
                <a
                  className={styles['terms-link']}
                  href={section.extra.url}
                >
                  {section.extra.text}
                </a>
              )}
              {section.extra && section.extra.type === 'notes' && (
                <div className={styles['terms-notes']}>
                  {section.extra.notes.map((note, i) => (
                    <div key={i}>{note}</div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* divider는 마지막 섹션이 아닐 때만 */}
          {idx !== termsData.length - 1 && (
            <div className={styles['term-divider']} />
          )}
        </React.Fragment>
      ))}
      
    </div>
  );
}

export default NavTermsNRefundsContent;
